/* globals Swiper */
export default function () {
	let wrap = '.menu-footer__container1';

	if ($(wrap).length === 0 || $(window).width() > 767) {
		return false;
	}

	return new Swiper(wrap, {
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		simulateTouch: false,
		roundLengths: true,
		navigation: {
			prevEl: '.footer__wrap .swiper-controls__back',
			nextEl: '.footer__wrap .swiper-controls__next',
		}
	});
}
